import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'upsc-collapsible-panel-light',
  templateUrl: './collapsible-panel-light.component.html',
  styleUrls: ['./collapsible-panel-light.component.scss']
})
export class CollapsiblePanelLightComponent {

  @Input() public isCollapsed = true;
  @Input() public title: string;
  @Input() public subtitle: string;

  @Output() collapsedEvent = new EventEmitter<boolean>(false);

  unCollapsed(){
    this.collapsedEvent.emit(true);
  }

  collapsed(){
    this.collapsedEvent.emit(false);
  }

}
